





import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { unwrapError } from '@/lib/helpers';
import { ExternalInvoiceService } from '@/lib/services';

@Component({})
export default class InvoiceViewPage extends Vue {
  error: string = '';
  shortId: string = '';

  async mounted(): Promise<void> {
    this.shortId = this.$route.params['id'];
    if (!this.shortId) {
      this.error = 'Invalid short code';
      return;
    }

    try {
      const blob = await ExternalInvoiceService.view(this.shortId);
      window.location.href = URL.createObjectURL(blob);
    } catch (e) {
      this.error = unwrapError(e);
    }
  }
}
